"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLOSUM_1 = require("./BLOSUM");
var SequenceSorter = /*#__PURE__*/function () {
  function SequenceSorter(key, description, isQuerySequenceDependent, targetAlignmentType, sortFn) {
    _classCallCheck(this, SequenceSorter);
    this.key = key;
    this.description = description;
    this.isQuerySequenceDependent = isQuerySequenceDependent;
    this.targetAlignmentType = targetAlignmentType;
    this.sortFn = sortFn;
  }
  /*
   *
   *
   * HELPER
   *
   *
   */
  _createClass(SequenceSorter, null, [{
    key: "hammingDistance",
    value: function hammingDistance(seq1, seq2) {
      var minLength = seq1.sequence.length < seq2.sequence.length ? seq1.sequence.length : seq2.sequence.length;
      //if they are not the same length, those extra positions in one
      //sequence count as differences to the other sequence
      var distance = Math.abs(seq1.sequence.length - seq2.sequence.length);
      for (var i = 0; i < minLength; i++) {
        if (seq1.sequence[i] !== seq2.sequence[i]) {
          distance += 1;
        }
      }
      return distance;
    }
  }, {
    key: "blosumScore",
    value: function blosumScore(seq1, seq2) {
      var minLength = seq1.sequence.length < seq2.sequence.length ? seq1.sequence.length : seq2.sequence.length;
      var score = 0;
      for (var i = 0; i < minLength; i++) {
        if (BLOSUM_1.BLOSUM62.has(seq1.sequence[i]) && BLOSUM_1.BLOSUM62.get(seq1.sequence[i]).has(seq2.sequence[i])) {
          score += BLOSUM_1.BLOSUM62.get(seq1.sequence[i]).get(seq2.sequence[i]);
        } else {
          //one or both letters are not in the blosum alignment. Occurs when
          //there are lower case letters or gaps.
          //TODO: is counting as zero the correct way to handle this?
        }
      }
      return score;
    }
  }, {
    key: "fromKey",
    value: function fromKey(key) {
      return SequenceSorter.list.find(function (at) {
        return at.key === key;
      });
    }
  }]);
  return SequenceSorter;
}();
exports.SequenceSorter = SequenceSorter;
/*
 *
 *
 * AVAILBLE SORT TYPES WITH FUNCTIONS
 *
 *
 */
SequenceSorter.INPUT = new SequenceSorter("as-input", "As input", false, "both", function (sequencesAsInput, alignment) {
  return sequencesAsInput;
});
SequenceSorter.HAMMING_DIST_QUERY = new SequenceSorter("hamming-dist-to-query", "Hamming distance to query sequence", true, "both", function (sequences, alignment) {
  var querySeq = alignment.getQuerySequence();
  return sequences.map(function (s) {
    return s;
  }).sort(function (seq1, seq2) {
    var dist1 = SequenceSorter.hammingDistance(querySeq, seq1);
    var dist2 = SequenceSorter.hammingDistance(querySeq, seq2);
    return dist1 - dist2;
  });
});
SequenceSorter.HAMMING_DIST_CONSENSUS = new SequenceSorter("hamming-dist-to-consensus", "Hamming distance to consensus sequence", true, "both", function (sequences, alignment) {
  var consensusSeq = alignment.getConsensus().sequence;
  return sequences.map(function (s) {
    return s;
  }).sort(function (seq1, seq2) {
    var dist1 = SequenceSorter.hammingDistance(consensusSeq, seq1);
    var dist2 = SequenceSorter.hammingDistance(consensusSeq, seq2);
    return dist1 - dist2;
  });
});
SequenceSorter.BLOSUM62_SCORE_CONSENSUS = new SequenceSorter("blosum-score-to-consensus", "BLOSUM62 score to consensus sequence", true, "aminoacid", function (sequences, alignment) {
  var consensusSeq = alignment.getConsensus().sequence;
  return sequences.map(function (s) {
    return s;
  }).sort(function (seq1, seq2) {
    var dist1 = SequenceSorter.blosumScore(consensusSeq, seq1);
    var dist2 = SequenceSorter.blosumScore(consensusSeq, seq2);
    return dist2 - dist1; //reverse from distance
  });
});
SequenceSorter.BLOSUM62_SCORE_QUERY = new SequenceSorter("blosum-score-to-query", "BLOSUM62 score to query sequence", true, "aminoacid", function (sequences, alignment) {
  var querySeq = alignment.getQuerySequence();
  return sequences.map(function (s) {
    return s;
  }).sort(function (seq1, seq2) {
    var dist1 = SequenceSorter.blosumScore(querySeq, seq1);
    var dist2 = SequenceSorter.blosumScore(querySeq, seq2);
    return dist2 - dist1; //reverse from distance
  });
});
/*
 *
 *
 * LIST OF ALL AVAILABLE OPTIONS
 *
 *
 */
SequenceSorter.list = [SequenceSorter.INPUT, SequenceSorter.HAMMING_DIST_QUERY, SequenceSorter.HAMMING_DIST_CONSENSUS, SequenceSorter.BLOSUM62_SCORE_QUERY, SequenceSorter.BLOSUM62_SCORE_CONSENSUS];
SequenceSorter.aminoAcidSorters = SequenceSorter.list.reduce(function (acc, seqSort) {
  if (seqSort.targetAlignmentType === "aminoacid" || seqSort.targetAlignmentType === "both") {
    acc.push(seqSort);
  }
  return acc;
}, []);
SequenceSorter.nucleotideSorters = SequenceSorter.list.reduce(function (acc, seqSort) {
  if (seqSort.targetAlignmentType === "nucleotide" || seqSort.targetAlignmentType === "both") {
    acc.push(seqSort);
  }
  return acc;
}, []);